var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-tab"},[_c('div',{ref:"header-wrap",staticClass:"pp-tab__header-wrap"},[_c('div',{ref:"header",class:[
                'pp-tab__header',
                _vm.scroll ? 'is-scroll' : 'is-flex',
            ],style:(_vm.headerStyle)},[_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,class:[
                    'pp-tab__header-item',
                    {'is-active': _vm.value === item.name,}
                ],style:({
                    width: _vm.width, 
                    flex: _vm.width ? '' : 1,
                }),on:{"click":function($event){return _vm.active(item.name)}}},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "+_vm._s(item.label)+" ")])}),_c('i',{staticClass:"pp-tab__header-line",style:(_vm.lineStyle)})],2)]),_c('div',{staticClass:"pp-tab__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }